<div class="home-container">
  <section class="home-content" *transloco="let t; read: 'home'">
    <div class="left">
      <h2>{{ t('subtitle') }}</h2>

      <h1>{{ 'app.title' | transloco }}</h1>

      <p>{{ t('intro') }}</p>

      <div class="button-container">
        @if ((isLoggedIn$ | async) === false) {
          <htx-button variant="secondary" icon="add_business" (buttonClick)="goToRegister()">
            {{ registerButtonKey | transloco }}
          </htx-button>
        }
      </div>

      @if (quickLinks().length > 0) {
        <div class="quick-links">
          <p class="quick-links-title">{{ t('quickLinks.title') }}</p>
          <div class="quick-links-grid">
            @for (link of quickLinks(); track link.route) {
              <button class="quick-link-tile" (click)="navigateTo(link.route)">
                <span class="material-icons quick-link-icon">{{ link.icon }}</span>
                <span class="quick-link-label">{{ link.labelKey | transloco }}</span>
              </button>
            }
          </div>
        </div>
      }
    </div>
    <div class="right">
      <img class="image" src="assets/images/htx-home-image.png" alt="" routerLink="/" />
    </div>
  </section>
</div>
